import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import AdminDashboard from 'views/admin/dashboard/AdminDashboard';
import CustomerList from 'views/admin/users/customers/CustomerList';
import CustomerDetailPage from 'views/admin/users/customers/CustomerDetailPage';
import RiderManagementPage from 'views/admin/users/rider/RiderManagementPage';
import RiderList from 'views/admin/users/riders/RiderList';
import VendorList from 'views/admin/users/vendors/VendorList';
// import AdminOrdersTable from 'views/admin/orders/AdminOrderList';
import VendorDetailPage from 'views/admin/users/vendors/VendorDetailPage';
import RiderDetailPage from 'views/admin/users/riders/RiderDetailPage';
import AdminCreateRider from 'views/admin/users/riders/CreateRider';
import TransactionsLog from 'views/admin/transaction/TransactionLog';
import AdminOrderDetail from 'views/admin/orders/AdminOrderDetail';
import AdminOrderList from 'views/admin/orders/AdminOrderList';
import MarketCategoryList from 'views/admin/marketCategory/MarketCategoryList';
import PayoutManagement from 'views/admin/payouts/PayoutsManagement';
import NotificationPage from 'views/common/notifications/NotificationPage';
import { element } from 'prop-types';
import Settings from 'views/admin/settings/Settings';
import PlatformSettings from 'views/admin/settings/AdminProfile';
import AdminProfile from 'views/admin/settings/AdminProfile';
import BannerList from 'views/admin/banner/BannerList';
import BannerForm from 'views/admin/banner/BannerForm';
import AdminStaffList from 'views/admin/users/staffs/AdminStaffList';
import PlatformEmployeeList from 'views/admin/users/employees/PlatformEmployeeList';
import VehicleTypeList from 'views/admin/vehicleTypes/VehicleTypeList';
import KycReviewBoard from 'views/admin/kyc/KycReviewBoard';
import KycDetailReview from 'views/admin/kyc/KycDetailReview';
import ComplaintList from 'views/admin/complaints/ComplaintList';
import ComplaintDetail from 'views/admin/complaints/ComplaintDetail';
import PromotionList from 'views/admin/promotions/PromotionList';
import PromotionForm from 'views/admin/promotions/PromotionForm';
import CategoryList from 'views/admin/categories/CategoryList';
import DispatchList from 'views/admin/dispatches/DispatchList';
import AuditLogList from 'views/admin/logs/AuditLogList';
import SystemFinancialReport from 'views/admin/reports/SystemFinancialReport';
import BroadcastMessaging from 'views/admin/messaging/BroadcastMessaging';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));

// ==============================|| MAIN ROUTING ||============================== //
const prefix = 'admin';
const AdminRoutes = [
    {
        path: '',
        element: <AdminDashboard />,
        prefix
    },
    {
        path: 'orders',
        element: <AdminOrderList />,
        prefix
    },
    {
        path: 'orders/:id',
        element: <AdminOrderDetail />,
        prefix
    },
    {
        path: 'market-categories',
        element: <MarketCategoryList />,
        prefix
    },
    {
        path: 'product-categories',
        element: <CategoryList />,
        prefix
    },
    {
        path: 'logistics',
        element: <DispatchList />,
        prefix
    },
    {
        path: 'audit-logs',
        element: <AuditLogList />,
        prefix
    },
    {
        path: 'payouts',
        element: <PayoutManagement />,
        prefix
    },
    {
        path: 'transactions',
        element: <TransactionsLog />,
        prefix
    },
    {
        path: 'customers',
        element: <CustomerList />,
        prefix
    },
    // customer detail
    {
        path: 'customers/:customerId',
        element: <CustomerDetailPage />,
        prefix
    },
    {
        path: 'riders',
        element: <RiderList />,
        prefix
    },
    {
        path: 'riders/new',
        element: <AdminCreateRider />,
        prefix
    },
    {
        path: 'riders/:riderId',
        element: <RiderDetailPage />,
        prefix
    },
    {
        path: 'vendors',
        element: <VendorList />,
        prefix
    },
    {
        path: 'vendors/:vendorId',
        element: <VendorDetailPage />,
        prefix
    },
    {
        path: 'settings',
        element: <Settings />,
        prefix
    },
    {
        path: 'profile',
        element: <AdminProfile />,
        prefix
    },
    {
        path: 'platform/settings',
        element: <PlatformSettings />,
        prefix
    },
    {
        path: 'notifications',
        element: <NotificationPage />,
        prefix
    },
    {
        path: 'messaging',
        element: <BroadcastMessaging />,
        prefix
    },
    {
        path: 'banners',
        element: <BannerList />,
        prefix
    },
    {
        path: 'banners/new',
        element: <BannerForm />,
        prefix
    },
    {
        path: 'banners/:id',
        element: <BannerForm />,
        prefix
    },
    {
        path: 'vendor-staffs',
        element: <AdminStaffList />,
        prefix
    },
    {
        path: 'platform-employees',
        element: <PlatformEmployeeList />,
        prefix
    },
    {
        path: 'vehicle-types',
        element: <VehicleTypeList />,
        prefix
    },
    {
        path: 'kyc',
        element: <KycReviewBoard />,
        prefix
    },
    {
        path: 'kyc/:userId',
        element: <KycDetailReview />,
        prefix
    },
    {
        path: 'complaints',
        element: <ComplaintList />,
        prefix
    },
    {
        path: 'complaints/:id',
        element: <ComplaintDetail />,
        prefix
    },
    {
        path: 'promotions',
        element: <PromotionList />,
        prefix
    },
    {
        path: 'promotions/create',
        element: <PromotionForm />,
        prefix
    },
    {
        path: 'promotions/:id',
        element: <PromotionForm />,
        prefix
    },
    {
        path: 'reports/financial',
        element: <SystemFinancialReport />,
        prefix
    }
];

export default AdminRoutes;
